import React from "react";
import { Link, useLocation } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  const loc = useLocation();
  return (
    <div className="relative min-h-[70vh] flex items-center justify-center px-6 py-16 overflow-hidden" data-testid="not-found-page">
      <Seo title="Page not found" description="The page you requested does not exist." noindex />

      {/* Sprint-polish 2026-05 — animated brand-mesh backdrop. Was bare
          text on bare background; only page on the site without the
          mesh-blob treatment. Now matches Pricing / Home pattern. */}
      <div aria-hidden="true" className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute -top-32 -left-24 w-[28rem] h-[28rem] rounded-full bg-brand-cyan/20 blur-3xl animate-blob" />
        <div className="absolute -bottom-40 -right-24 w-[32rem] h-[32rem] rounded-full bg-brand-violet/20 blur-3xl animate-blob" style={{ animationDelay: "-4s" }} />
        <div className="absolute top-1/3 left-1/2 w-[20rem] h-[20rem] rounded-full bg-brand-pink/15 blur-3xl animate-blob" style={{ animationDelay: "-8s" }} />
      </div>

      <div className="relative max-w-xl text-center">
        {/* Massive gradient 404. The number reads as the hero; the rest
            of the page is supporting copy. */}
        <div
          className="font-display font-black text-[10rem] sm:text-[12rem] leading-none tracking-tighter bg-clip-text text-transparent bg-brand-flow animate-gradient-shift"
          style={{ backgroundSize: "200% 200%" }}
        >
          404
        </div>

        <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-text2 mt-2">page not found</div>
        <h1 className="font-display text-3xl sm:text-4xl text-text1 mt-3 tracking-tight">
          This page took a different horizon
        </h1>
        <p className="font-body text-text2 mt-4 text-base leading-relaxed">
          Nothing lives at{" "}
          <code className="font-mono text-amber1 bg-amber1/10 px-2 py-0.5 rounded border border-amber1/20">
            {loc.pathname}
          </code>
          . Maybe a typo, maybe the page moved.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3 mt-8">
          <Link
            to="/"
            className="font-display text-sm font-medium bg-amber1 text-bg px-6 h-11 inline-flex items-center rounded-full hover:bg-amber2 shadow-[0_0_18px_rgba(244,201,93,0.3)] hover:shadow-[0_0_28px_rgba(244,201,93,0.5)] transition-all"
          >
            ← Home
          </Link>
          <Link
            to="/browse"
            className="font-display text-sm font-medium border border-border1 text-text1 px-6 h-11 inline-flex items-center rounded-full hover:border-amber1 hover:text-amber1 transition-all"
          >
            Browse plugins
          </Link>
          <Link
            to="/docs"
            className="font-display text-sm font-medium border border-border1 text-text1 px-6 h-11 inline-flex items-center rounded-full hover:border-amber1 hover:text-amber1 transition-all"
          >
            Docs
          </Link>
        </div>

        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-text2/60 mt-12">
          ⌁ Horizon AI
        </div>
      </div>
    </div>
  );
}
